import { QuestelServicesClient, RequestResult, HttpMethodEnum } from '@questelservices/common';
import store from '../store';
import { InfractionTypeDto } from '../models/infractions/InfractionTypeDto';
import { ManualCodeInvoiceLineItemDto } from '../models/ManualCodeInvoiceLineItemDto';

export class InfractionService {
    client: QuestelServicesClient;

    constructor() {
        this.client = new QuestelServicesClient(store, '')
    }

    async GetInfractionsPerLineItem(id: string): Promise<InfractionTypeDto[]> {
        return await this.client.get<InfractionTypeDto[]>(`/api/manualcoding/${id}/infractions`);
    }

    async ConfirmInfractions(id: string, payload: string): Promise<ManualCodeInvoiceLineItemDto> {
        return await this.client.getPostData<ManualCodeInvoiceLineItemDto>(`/api/manualcoding/${id}/confirm-infractions`, payload);
    }

    async AddInfraction(id: string, payload: InfractionTypeDto[]): Promise<ManualCodeInvoiceLineItemDto> {
        return await this.client.getPostData<ManualCodeInvoiceLineItemDto>(`/api/manualcoding/${id}/add-infractions`, payload);
    }

    async GetAllInfractionTypes(): Promise<InfractionTypeDto[]> {
        return await this.client.get<InfractionTypeDto[]>(`/api/manualcoding/infraction-types`);
    }

    async GetAllInfractions(id: string) : Promise<InfractionTypeDto[]> {
        return await this.client.get<InfractionTypeDto[]>(`/api/manualcoding/${id}/infractions/display`);
    }
}